<template>
    <div id="app">
        <router-view name="public"/>
        <router-view name="404public"/>
        <router-view name="secure"/>
    </div>
</template>
<script>
    export default {
        watch:{
           '$route': async function() {

            const user = localStorage.getItem("user");
            if(!user) return;

            const token = localStorage.getItem('loginToken'); 
            try {
              await this.axios.get(`${this.$urls.VALIDAR_TOKEN}?token=${token}`);

            } catch (error) {
                    localStorage.clear();
                    this.$router.replace({ path: '/', name: 'public' })
                }
            }
        }
    }
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Sarabun:400,500,600");
    body{
        font-family: "Sarabun", sans-serif, Helvetica, Arial !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        &::-webkit-scrollbar-track{
            box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar{
            width: 6px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb{
            background-color: #5e5e5e;
        }
    }
    #carousel div.carousel-caption {
        top: 40%;
        bottom: auto;
        h3 {
            font-size: 3em;
        }
        p {
            font-size: 1.1em;
            font-weight: 400;
        }
    }
    .el-message--error {
        border-color: #fdd1d1 !important;
        top: 70px !important;
    }
    .white-box {
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 8px;
        background: #fff;
        box-shadow: 1px 2px 1px #d3d3d3;
    }

    @import '@/assets/css/globalStyle.scss';

    .f360-ntable {
        border-collapse: separate;
        border-spacing: 10px;
        thead.is-group th.el-table__cell {
            background: #ffffff !important;
        }

        &.el-table--border, &.el-table--group {
            border: 1px solid #B0B0B0;
            border-radius: 5px;
        }

        &.el-table--border th.el-table__cell, &.el-table__fixed-right-patch {
            border-bottom: none;
        }

        &.el-table--border .el-table__cell, &.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
            border-right: none;
        }

        th.el-table__cell {
            color: #000;
            vertical-align:bottom;
            line-height: 10px;
        }

        tbody .cell {
            color: #000;
            vertical-align:bottom;
            line-height: 10px !important;
            max-width: 100% !important;
            .bold-text {
                font-weight:900; 
            }
        }
        .is-center {
                text-align:center !important;
            .cell {
                text-align:center !important;
            }
        }
        
        span.caret-wrapper {
            display: none !important;
        }
        td.is-left div{
            text-align: left !important;
            display: inline-block;
        }
        td.is-right div{
            text-align: right;
            display: inline-block;
        }
        thead tr:first-child th.cell-spacing-tb.el-table__cell {
            .cell{
                padding: 5px;
            }
        }

        thead th.el-table__cell {
            .cell{
                padding: 5px;
            }
            &.is-left { 
                text-align: left !important;
                .cell {
                    text-align: left !important;
                }
            }
            &.is-right { 
                text-align: right !important;
                .cell {
                    text-align: right !important;
                }
            }
            &.is-center { 
            text-align: center !important;
                .cell {
                    text-align: center !important;
                }
            }
            
        }
    }
</style>
